import { createSelector } from 'reselect';

export const createdChallengeState = (state) =>
    state.createChallenge.createdChallenge || [];

export const creatingChallengeState = (state) =>
    state.createChallenge.creatingChallenge || false;

export const getCreatedChallenge = createSelector(
    createdChallengeState,
    (challenge) => challenge,
);

export const getFeaturedChallengesState = (state) =>
    state.createChallenge.featuredChallenges || [];

export const getFeaturedChallenges = createSelector(
    getFeaturedChallengesState,
    (featuredChallenges) => featuredChallenges,
);

export const getCreateChallengeErrorState = (state) =>
    state.createChallenge.createChallengeError || null;

export const getCreateChallengeError = createSelector(
    getCreateChallengeErrorState,
    (error) => error,
);
